import inviteSetting from "@/components/invite/invite-setting.vue";
import applyRecord from "@/components/invite/apply-record.vue";
export default {
  name: "InviteSetting",
  components: {
    inviteSetting,
    applyRecord
  },
  data() {
    return {
      activeTab: "",
      tabList: [{
        label: $t("itasrr4", "邀请设置"),
        name: "inviteSetting",
        component: inviteSetting
      }, {
        label: $t("fd2e6t4", "申请列表"),
        name: "applyRecord",
        component: applyRecord
      }]
    };
  },
  methods: {
    checkInvite(item) {
      this.activeTab = "applyRecord";
      this.$refs.inviteRef[1].refresh(item);
    },
    changeTab(item) {
      if (item === "inviteSetting") {
        this.$refs.inviteRef[1].reset();
        this.$refs.inviteRef[0].init();
      }
    }
  }
};